module.exports = __webpack_public_path__ + "static/media/pieChart.32b3b4e4.png";